import React, { useEffect } from "react";
import { useInput } from "../../../../common/hooks";
import { Input, Form } from "semantic-ui-react";
import "./style.less";
import { useSelector, useDispatch } from "react-redux";
import { setSearchQueryFilter } from "../../../../redux/geofence/actions";
import CategoryFilter from "./CategoryFilter";
import FilteredGeofencesLists from "../FilteredGeofencesLists";

function FenceFilter() {
  const [fenceNameInputVal, setFenceNameInputVal] = useInput("");
  const filter = useSelector(({ geofence }) => geofence.filter);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setSearchQueryFilter(fenceNameInputVal));
  }, [dispatch, fenceNameInputVal]);
  return (
    <div className="FenceFilter">
      <h2>Search Area</h2>
      <Form inverted>
        <Input
          inverted
          icon="search"
          placeholder="Search..."
          value={fenceNameInputVal}
          onChange={setFenceNameInputVal}
        />
      </Form>
      <br />
      <CategoryFilter />
      <br />
      <br />
      <br />
      {filter.categoriesToShow === null && !filter.searchQuery ? null : (
        <div className="FilteredGeofencesListContainer">
          <FilteredGeofencesLists />
        </div>
      )}
    </div>
  );
}

FenceFilter.defaultProps = {};

FenceFilter.propTypes = {};

export default FenceFilter;
